import type { SceneModule } from '../_shared/types'
import NewsBrief from './NewsBrief'
import { NewsBriefEditor } from './Editor'
import { render } from './svgRender'
import { NewsBriefComposition } from './Composition'

export const module: SceneModule = {
  id: 'news-brief',
  Component: NewsBrief,
  Composition: NewsBriefComposition,
  Editor: NewsBriefEditor,
  svgRender: render,
}
